import { useMemo } from 'react'
import useOfferList from 'hooks/Offers/useOfferList'
import { OFFER_TYPE_BUNDLE_AND_SAVE, OFFER_TYPE_HOTEL } from 'constants/offer'
import useOfferListSortOptions from 'hooks/useOfferListSortOptions'
import { ANYWHERE_PLACE_ID } from 'constants/search'
import config from 'constants/config'

interface Options {
  disabled?: boolean
  limit?: number
}

/**
 * Fetches offers sorted by ending soon
 * Returns offers that are close to their end date, sorted by those ending soonest first
 */
export default function useEndingSoonOfferList(options: Options = {}): App.OfferList {
  const { SORT_OPTION_ENDING_SOON } = useOfferListSortOptions()
  const defaultRooms = useMemo(() => [config.search.defaultOccupants], [])
  const { disabled, limit } = options

  const listFilters = useMemo<App.OfferListFilters>(() => ({
    offerTypes: [OFFER_TYPE_HOTEL, OFFER_TYPE_BUNDLE_AND_SAVE],
    frontPageVisibleOnly: true,
    isStream: true,
    ...(limit ? { limit } : {}),
    sortBy: SORT_OPTION_ENDING_SOON.value as App.OfferListSortByOptions,
    destinationId: ANYWHERE_PLACE_ID,
    destinationName: 'Anywhere',
    rooms: defaultRooms,
  }), [defaultRooms, SORT_OPTION_ENDING_SOON, limit])

  return useOfferList(listFilters, { disabled, minRequiredOffers: limit })
}
